import { NgModule } from '@angular/core';
import { RecaptchaModule } from 'ng-recaptcha';
import { ToggleSwitchModule } from '../../../../shared/toggle-switch/toggle-switch.module';
import { SharedModule } from '../../../../shared/shared.module';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { AddOrgBankAccountDialogComponent } from './add-org-bank-account-dialog.component';
import { PlaidSearchModule } from '../plaid-search/plaid-search.module';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { ErrorClassWhenInvalidModule } from '../../../../../directives/error-class-when-invalid/error-class-when-invalid.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { LastCharactersPipeModule } from '../../../../../pipes/format/last-characters.module';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { BankAccountPropertiesModule } from '../bank-account-properties/bank-account-properties.module';

@NgModule({
    imports: [
        SharedModule,
        RecaptchaModule,
        ToggleSwitchModule,
        MatButtonModule,
        MatIconModule,
        MatSlideToggleModule,
        PlaidSearchModule,
        MatDialogModule,
        ErrorClassWhenInvalidModule,
        MatExpansionModule,
        LastCharactersPipeModule,
        MatSelectModule,
        BankAccountPropertiesModule,
    ],
    exports: [AddOrgBankAccountDialogComponent],
    declarations: [AddOrgBankAccountDialogComponent],
})
export class AddOrgBankAccountDialogModule
{
}
